import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea"]

  connect() {
    console.log('📏 Auto Resize Controller connected')
    this.isSubmitting = false
    
    // Initialize all textareas
    this.textareaTargets.forEach(textarea => {
      this.initializeTextarea(textarea)
    })
  }

  textareaTargetConnected(textarea) {
    console.log('📝 New textarea connected to auto-resize')
    this.initializeTextarea(textarea)
  }

  initializeTextarea(textarea) {
    // Set initial height based on content
    this.resize(textarea)
    
    // Add event listeners
    textarea.addEventListener('input', () => this.resize(textarea))
    textarea.addEventListener('keydown', (e) => this.handleKeydown(e, textarea))
  }

  resize(textarea) {
    // Reset height to auto to get the actual scrollHeight
    textarea.style.height = 'auto'
    
    // Get the minimum height from style or default
    const minHeight = parseInt(textarea.style.minHeight) || 50
    
    // Set height to scrollHeight with some padding, respecting minimum
    const newHeight = Math.max(minHeight, Math.min(textarea.scrollHeight, 120))
    textarea.style.height = newHeight + 'px'
  }

  handleKeydown(event, textarea) {
    // Handle Enter key behavior
    if (event.key === 'Enter' && !event.shiftKey) {
      // Check if this is a comment form (has a submit button)
      const form = textarea.closest('form')
      if (form) {
        const submitButton = form.querySelector('input[type="submit"], button[type="submit"]')
        if (submitButton) {
          event.preventDefault()
          
          // Only submit if there's content and not already submitting
          const content = textarea.value.trim()
          if (content.length > 0 && !this.isSubmitting) {
            this.isSubmitting = true
            const formId = form.id || form.querySelector('input[name="authenticity_token"]')?.value?.slice(0,8) || 'unknown'
            console.log(`⏎ Submitting form via Enter key (form: ${formId})`)
            form.requestSubmit(submitButton)
            
            // Reset after a short delay
            setTimeout(() => {
              this.isSubmitting = false
            }, 1000)
          }
        }
      }
    }
  }

  reset(event) {
    console.log('🔄 Resetting form after successful submission')
    
    // Clear all textareas in this form
    this.textareaTargets.forEach(textarea => {
      textarea.value = ''
      // Reset height to minimum
      const minHeight = parseInt(textarea.style.minHeight) || 50
      textarea.style.height = minHeight + 'px'
    })
    
    // Reset submission flag
    this.isSubmitting = false
  }
}